import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal } from '@angular/core';

import { SearchResultItem } from '~/repositories/search/store/search.models';
import { IColumn } from '~/repositories/search/store/search.types';

interface PageEvent {
  first?: number;
  rows?: number;
  page?: number;
  pageCount?: number;
}

@Component({
  selector: 'app-results-table',
  templateUrl: './results-table.component.html',
  styleUrls: ['./results-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ResultsTableComponent {
  @Input() set results(items: SearchResultItem[]) {
    items && this.displayedResults.set(items);
  }
  @Input() loading: boolean;
  @Input() pageLoading: boolean;
  @Input() rows?: number;
  @Input() totalRecords?: number;
  @Input() first?: number;
  @Input() columns: IColumn[];
  @Input() sortField?: string;
  @Input() sortOrder?: number;

  @Output() rowClicked: EventEmitter<SearchResultItem> = new EventEmitter();
  @Output() pageChange?: EventEmitter<{ first: number; rows: number }> = new EventEmitter();
  @Output() changeRowCount?: EventEmitter<number> = new EventEmitter();
  @Output() changeSorting?: EventEmitter<{
    sortColumn: string;
    sortOrder: string;
  }> = new EventEmitter();

  public placeHolderRows = Array(4).fill({
    id: '',
    title: '',
    author: ''
  });

  public displayedResults = signal(this.placeHolderRows);

  public onChangePage(event: PageEvent) {
    this.pageChange.emit({ first: event.first, rows: event.rows });
  }

  public onChangeRowCount(value: number) {
    this.changeRowCount.emit(value);
  }

  public onRowClicked(item: SearchResultItem) {
    this.rowClicked.emit(item);
  }

  public sortResults({ field, order }: { field: string; order: number }) {
    if (field !== this.sortField || order !== this.sortOrder) {
      this.changeSorting.emit({
        sortColumn: field,
        sortOrder: order === 1 ? 'ASC' : 'DESC'
      });
    }
  }
}
